module.exports = __webpack_public_path__ + "static/media/vivi-pensando-esquerda.7fca7fef.svg";